<template>
  <div>
    <v-container
      v-if="!contentPage"
      class="fill-height"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          class="mx-auto"
        >
          Cargando...
          <v-icon>
            mdi-timer-sand-empty mdi-spin
          </v-icon>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="viewPage">
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-if="episode_id == 0"
          cols="12"
        >
          <v-container
            class="fill-height"
            fluid
          >
            <v-row
              align="center"
              justify="space-around"
            >
              <v-col
                cols="12"
                sm="6"
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Última conexión: {{ lastSignInTime }}</v-list-item-subtitle>
                    <v-list-item-subtitle>
                      Promedio de respuestas correctas por nivel: {{ average }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      Estudiante: {{ user.name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-progress-linear
                  :model="countLevels"
                  :value="countLevels*12.50"
                  height="20"
                >
                  <strong>{{ (countLevels*12.50).toFixed(2) }}%</strong>
                </v-progress-linear>
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                Episodio {{ episode_id + 1 }}
                <v-select
                  v-model="report_option"
                  label="Seleccione evaluación"
                  :items="options"
                  item-text="label"
                  outlined
                />
              </v-col>
            </v-row>
          </v-container>
          <v-divider />
          <v-container
            class="fill-height"
            fluid
          >
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="12"
                lg="7"
              >
                <v-item-group
                  ref="item"
                  multiple
                >
                  <v-container
                    class="fill-height"
                  >
                    <v-row
                      align="center"
                      justify="center"
                    >
                      <v-col
                        v-for="(level, index) in levels"
                        :key="index"
                        cols="6"
                        sm="4"
                        md="3"
                        class="justify-center"
                      >                      
                        <v-hover v-slot:default="{ hover }">
                          <v-card
                            max-width="150"
                            :disabled="userType != 'student' && index > 0"
                          >
                            <v-toolbar
                              dark
                              color="primary"
                            >
                              <v-toolbar-title class="text-center">
                                Nivel {{ index + 1 }}
                              </v-toolbar-title>
                            </v-toolbar>

                            <v-card-title class="headline text-center mb-5 font-weight-bold">
                              {{ level.total_correct }}/{{ level.total_answered }}
                            </v-card-title>

                            <v-card-actions class="justify-center">
                              <v-icon large>
                                {{ userType != 'student' && index > 0 ? 'mdi-lock' : level.locked ? 'mdi-lock' : 'mdi-lock-open-variant' }}
                              </v-icon>
                            </v-card-actions>
                            <v-fade-transition>
                              <v-overlay
                                v-show="hover"
                                absolute
                                color="#036358"
                              >
                                <!-- <dialog-lists-exercise
                                  v-if="level.total_answered === 20"
                                  :item="index"
                                /> -->
                                <dialog-lists-report-student
                                  v-if="level.total_answered === 20"
                                  :item="index"
                                  :level="level"
                                />
                              </v-overlay>
                            </v-fade-transition>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-item-group>
              </v-col>
              <v-col
                cols="12"
                lg="5"
              >
                <base-material-chart-card
                  :data="dataCompletedTasksChart.data"
                  :options="dataCompletedTasksChart.options"
                  hover-reveal
                  color="info"
                  type="Line"
                >
                  <h3 class="card-title font-weight-light mt-2 ml-2">
                    Respuestas correctas por nivel
                  </h3>
                  <template v-slot:actions>
                    <v-icon
                      class="mr-1"
                      small
                    />
                    <span class="caption grey--text font-weight-light" />
                  </template>
                </base-material-chart-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col v-else>
          Episodio no disponible.
        </v-col>
      </v-row>

      <help-button
        :tutorial="tutorial"
      />
    </v-container>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import HelpButton from '@/views/dashboard/pages/panel/HelpButton'
  import DialogListsExercise from '@/views/dashboard/pages/panel/DialogListsExercise'
  import DialogListsReportStudent from '@/views/dashboard/pages/panel/DialogListsReportStudent'

  export default {
    components: {
      HelpButton,
      DialogListsExercise,
      DialogListsReportStudent,
    },
    data () {
      return {
        userType: '',
        viewPage: false,
        contentPage: false,
        items: [],
        tutorial: 'player-progress-student',
        name: '',
        nickname: '',
        episode_id: -1,
        uid: '',
        history: {},
        documents: {},
        levels: [],
        options: [
          { value: 0, label: 'Evaluacion #1' },
          { value: 1, label: 'Evaluacion #2' },
        ],
        report_option: 0,
        levels_history: [],
        average: -1,
        countLevels: 0,
        currentLevelQuizzes: [],
        levelsData: [],
        levelsLabel: [],
        lastSignInTime: null,
        lastSignInTimeUrl:
          'https://us-central1-videojuego-sh.cloudfunctions.net/lastSignInTime',
        overlay: false,
        dialog: false,
        student: '',
        dataCompletedTasksChart: {
          data: {
            labels: ['Nivel 1', 'Nivel 2', 'Nivel 3', 'Nivel 4', 'Nivel 5', 'Nivel 6', 'Nivel 7', 'Nivel 8'],
            series: [
              [],
            ],
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0,
            }),
            low: 20,
            showArea: true,
            high: 20, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 20,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
        },
      }
    },
    computed: {
      ...mapState(['user', 'userData']),
    },
    watch: {
      $route (to, from) {
        this.episode_id = to.params.id
      },
      report_option (value) {
        this.selectReport(value)
      },
      levels (val) {
        this.dataCompletedTasksChart.data.series = []

        const series = []
        val.map((data, i) => {
          series.push(data.total_correct)
        })

        this.dataCompletedTasksChart.data.series = [series]
      },
    },
    updated: function () {
      var ref = this
      this.$nextTick(function () {
        if (typeof ref.$refs.item !== 'undefined') {
          this.contentPage = true
        }
      })
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.episode_id = this.$route.params.id
        if (this.episode_id === 0 || this.episode_id === '0') {
          this.$store.commit('SET_LOADING', true)
          const currentUser = firebase.auth().currentUser
          this.uid = currentUser.uid
          this.getUser(this.uid)
          this.getLastSignInTime(this.uid)
        }
      },
      getLastSignInTime (uid) {
        axios
          .post(this.lastSignInTimeUrl, {
            uid: uid,
          })
          .then((response) => {
            const data = response.data
            const error = data.error
            if (!error) {
              // const message = data.message
              this.lastSignInTime = data.lastSignInTime
            } else {
              this.$store.commit('SET_LOADING', false)
            }
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false)
            console.log(error)
            alert(error)
          })
      },
      getUser (uid) {
        firebase
          .firestore()
          .collection('users')
          .doc(uid)
          .get()
          .then((response) => {
            const data = response.data()
            this.name = `${data.firstname} ${data.lastname}`
            this.nickname = data.nickname
            this.history = data.history
            this.levels_history = this.history.episode_1.levels
            this.setData()
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false)
            console.log(error)
            alert(error)
          })
      },
      setData () {
        this.getQuizzes()
      },
      getQuizzes () {
        var quizzes = {}
        firebase
          .firestore()
          .collection('quiz')
          .where('user_id', '==', this.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((document) => {
              const data = document.data()
              const levelId = data.level_id
              if (quizzes[levelId] == null) {
                quizzes[levelId] = []
              }
              quizzes[levelId].push(document)
            })
          })
          .then(() => {
            this.documents = {}
            for (var i = 0; i < 8; i++) {
              var levelId = `010${i + 1}`
              if (quizzes[levelId] != null) {
                this.getInformation(quizzes[levelId], levelId)
              }
            }
          })
          .then(() => {
            this.selectReport(0)
          })
      },
      getInformation (docsData, levelId) {
        const docs = []

        for (var i = 0; i < docsData.length; i++) {
          var document = docsData[i]
          const data = document.data()
          const endTime = data.end_time
          if (endTime != null) {
            docs.push(document)
          }
        }

        docs.sort(
          (a, b) =>
            new Date(a.data().end_time.toDate()).getTime() -
            new Date(b.data().end_time.toDate()).getTime(),
        )

        this.documents[levelId] = docs.slice(0, 2)
      },
      selectReport (index) {
        this.levels = []
        this.levelsLabel = []
        this.levelsData = []

        this.countLevels = 0
        this.average = 0

        for (var i = 0; i < 8; i++) {
          var levelId = `010${i + 1}`
          var locked = this.levels_history[i].locked

          var level = {}
          if (this.documents[levelId] != null) {
            if (
              this.documents[levelId].length > 0 &&
              this.documents[levelId][index] != null
            ) {
              var document = this.documents[levelId][index]
              var data = document.data()

              const answers = String(data.answers)
              const collectibles = String(data.collectibles)
              const totalCollected = collectibles.split('1').length - 1

              const playTimeSeconds =
                data.play_time != null ? data.play_time : 0
              const solveTimeSeconds =
                data.solve_time != null ? data.solve_time : 0

              var playTimeDate = new Date(null)
              playTimeDate.setSeconds(playTimeSeconds)
              const playTime = playTimeDate.toISOString().substr(11, 8)

              var solveTimeDate = new Date(null)
              solveTimeDate.setSeconds(solveTimeSeconds)
              const solveTime = solveTimeDate.toISOString().substr(11, 8)

              const totalCorrect = answers.split('2').length - 1

              const totalAnswered = 20 - (answers.split('0').length - 1)

              if (totalAnswered === 20) {
                this.average += totalCorrect
                this.countLevels += 1
              }

              level = {
                locked: locked,
                play_time: playTime,
                solve_time: solveTime,
                total_correct: totalCorrect,
                total_answered: totalAnswered,
                total_collected: totalCollected,
                answers,
              }
            } else {
              level = {
                locked: locked,
                play_time: '99:99',
                solve_time: '99:99',
                total_correct: 0,
                total_answered: 0,
                total_collected: 0,
              }
            }
          } else {
            level = {
              locked: locked,
              play_time: '99:99',
              solve_time: '99:99',
              total_correct: 0,
              total_answered: 0,
              total_collected: 0,
            }
          }

          this.levels.push(level)
        }
        if(this.countLevels > 0)
          this.average /= this.countLevels
        this.average = this.average.toFixed(2)

        this.$store.commit('SET_LOADING', false)
        this.viewPage = true
      },
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        const userData = await vm.$store.dispatch('GET_USER_DATA')
        if (userData.type !== 'admin') {
          vm.userType = userData.type
          vm.viewPage = true
          next()
        } else {
          console.log('Está intentando ingresar a una pagina no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }
</script>

<style scoped>
.foreground {
   position:absolute;
    height:100%;
    width:100%;
    background-color:black;
    opacity:0.7;
    pointer-events:none;
}
</style>